import { useMutation } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';
import { IServerErrorResponse } from '../../../../types';

interface IProps {
    customerId: string;
    invoicePayload: any;
    invoiceId: string;
}

export const useUpdateExistingInvoice = (onSuccess: (res: any) => void, onError?: (err: IServerErrorResponse) => void) => useMutation(
  'useUpdateExistingInvoice',
  async ({
    customerId, invoicePayload, invoiceId,
  }: IProps) => {
    delete invoicePayload.invoiceReminders;

    if (invoicePayload.invoicePaymentTerm.achPaymentMethod === 'FALSE') {
      invoicePayload.invoicePaymentTerm.achPaymentMethod = false;
    }

    if (invoicePayload.invoicePaymentTerm.checkDepositPaymentMethod === 'FALSE') {
      invoicePayload.invoicePaymentTerm.checkDepositPaymentMethod = false;
    }

    const res = await httpService.put(`${BASE_URL}/api/v2/user/${customerId}/invoice/${invoiceId}`, { ...invoicePayload });
    return res.data;
  },
  {
    retry: 0,
    onSuccess: (res => {
      onSuccess(res);
    }),
    onError: ((err: IServerErrorResponse) => {
      if (onError) {
        onError(err);
      }
    }),
  },
);
